import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { defaultCheckboxStyle } from '../atoms';
import { defaultTextProps } from '../atoms/Texts';
import {
    defaultButtonStyle,
    defaultInputStyles,
    defaultProgressDotsStyle,
    defaultToggleButtonStyle,
} from '../molecules';
import { dnbTheme } from './dnb';
import GlobalFonts from './fonts';
import { postenTheme } from './posten/posten';
import { postenBring } from './posten/postenBring';
import { Theme, Themes } from './types';

export const themes: Record<Themes, Theme> = {
    default: {
        button: defaultButtonStyle,
        checkbox: defaultCheckboxStyle,
        progressDots: defaultProgressDotsStyle,
        texts: defaultTextProps,
        toggleButton: defaultToggleButtonStyle,
        input: defaultInputStyles,
    },
    dnb: dnbTheme,
    posten: postenTheme,
    postenBring,
};

type Props = {
    children: React.ReactNode;
    themeName: Themes;
    shouldExcludeFont?: boolean;
};

export const ThemeProvider = ({
    children,
    themeName,
    shouldExcludeFont,
}: Props) => {
    const theme = getTheme(themeName);
    return (
        <StyledThemeProvider theme={theme}>
            <GlobalFonts
                themeName={themeName}
                shouldExcludeFont={shouldExcludeFont}
            />
            {children}
        </StyledThemeProvider>
    );
};

export const getTheme = (company: Themes): Theme => {
    return themes[company] || themes.default;
};
